import { calcNoteSymbolicDuration, calculateKey } from "@/util/util";

export const STAFF_FIVE_LINES = '\uE014';
export const G_CLEF = '\uE050',
    F_CLEF = '\uE062', BAR_BEGIN = '\uE030', BAR_END = '\uE030'

// before B - use note up, otherwise TODO: use note down
const NOTE_WHOLE = '\uE1D2',
    NOTE_HALF_UP = '\uE1D3',
    NOTE_HALF_DOWN = '\uE1D4',
    NOTE_QUARTER_UP = '\uE1D5',
    NOTE_QUARTER_DOWN = '\uE1D6',
    NOTE_EIGHTH_UP = '\uE1D7',
    NOTE_EIGHTH_DOWN = '\uE1D8',
    NOTE_SIXTEENTH_UP = '\uE1D9',
    NOTE_SIXTEENTH_DOWN = '\uE1DA',
    NOTE_THIRTY_SECONDTH_UP = '\uE1DB',
    NOTE_THIRTY_SECONDTH_DOWN = '\uE1DC',
    NOTE_SIXTY_FOURTH_UP = '\uE1DD',
    NOTE_SIXTY_FOURTH_DOWN = '\uE1DE';

const REST_WHOLE = '\uE4E3', REST_HALF = '\uE4E4', REST_QUARTER = '\uE4E5',
    REST_EIGHTH = '\uE4E6', REST_SIXTEENTH = '\uE4E7';

const AUGMENTATION_DOT = '\uE1E7';

export function mapNoteDebug(note) {
    let string = note.timeSeconds;
    return string;
}

export function mapNote(note, divisions) {
    if (note.pitch) {
        let mapping = '';
        switch (note.type) {
            case 'whole': mapping = NOTE_WHOLE; break;
            case 'half': mapping = note?.stem === 'down' ? NOTE_HALF_DOWN : NOTE_HALF_UP; break;
            case 'quarter': mapping = note?.stem === 'down' ? NOTE_QUARTER_DOWN : NOTE_QUARTER_UP; break;
            case 'eighth': mapping = note?.stem === 'down' ? NOTE_EIGHTH_DOWN : NOTE_EIGHTH_UP; break;
            case '16th': mapping = note?.stem === 'down' ? NOTE_SIXTEENTH_DOWN : NOTE_SIXTEENTH_UP; break;
            case '32nd': mapping = note?.stem === 'down' ? NOTE_THIRTY_SECONDTH_DOWN : NOTE_THIRTY_SECONDTH_UP; break;
            case '64th': mapping = note?.stem === 'down' ? NOTE_SIXTY_FOURTH_DOWN : NOTE_SIXTY_FOURTH_UP; break;
            default: {
                console.warn(`no mapping for `, note);
                mapping = '\uEDA6';
            }
        }
        const fullDuration = note.duration;
        const symbolDuration = calcNoteSymbolicDuration(note, divisions);
        if (fullDuration > symbolDuration) {
            mapping += AUGMENTATION_DOT;
        }
        if (note.pitch.step.includes('#')) {
            mapping+='#'
        } else if (note.pitch.step.includes('b') && note.pitch.step.length > 1) {
            mapping+='b';
        }
        return mapping;
    } else {
        switch (note.type) {
            case 'whole': return REST_WHOLE;
            case 'half': return REST_HALF;
            case 'quarter': return REST_QUARTER;
            case 'eighth': return REST_EIGHTH;
            case '16th': return REST_SIXTEENTH;
            default: {
                if (note.rest && note.rest['@_measure'] === 'yes' || note.rest === "") {
                    return REST_WHOLE;
                }
                console.warn(`no mapping for `, note);
                return '\uEDA6';
            }
        }
    }
}

export function mapKey(key) {
    return calculateKey(key);
}

export function pitchToHeight(note, key = 'C' ) {
    if (!note.pitch) {
        switch (note.staff) {
            case 1: return 4;
            case 2: return 5;
        }
    }

    switch (note.staff) {
        case 1: return getPositionGCleff(note, key) + (note.pitch.octave - 4) * 7;
        case 2: return getPositionFCleff(note, key) + + (note.pitch.octave - 2) * 7;
        default: return 0;
    }
}

function getPositionGCleff(note, key) {
    // E = 0;
    switch (note.pitch.step) {
        case 'C': return -2;
        case 'D': return -1;
        case 'E': return 0;
        case 'F': return 1;
        case 'G': return 2;
        case 'A': return 3;
        case 'B': return 4;
        default: 0;
    }
}

function getPositionFCleff(note, key) {
    switch (note.pitch.step) {
        case 'B': return 2;
        case 'A': return 1;
        case 'G': return 0;
        case 'F': return -1;
        case 'E': return -2;
        case 'D': return -3;
        case 'C': return -4;
        default: return 0;
    }
}